import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import { Breadcrumbs } from '../Breadcrumb';
import { Grid, GridCell } from '../Grid';
import Body1 from '../Typography/Body/Body1';
import Headline3 from '../Typography/Heading/Headline3';
import breakpoints from '../Theme/breakpoints';

const MarketGrid = styled(Grid)`
  &&& {
    padding: 0 0 8px;
  }
`;

const StyledHeadline3 = styled(Headline3)`
  && {
    text-align: center;
    margin: 52px 16px 16px;
  }
`;

const MarketDescription = styled(Body1)`
  && {
    text-align: center;
    margin: 0 0 32px;

    && {
      font-family: ${({ theme }) => theme.fonts.primary};
      letter-spacing: 0;
    }
  }
`;

const MarketBody = styled.div`
  &&& {
    font-family: ${({ theme }) => theme.fonts.primary};

    p, span, div, strong {
      font-family: ${({ theme }) => theme.fonts.primary};
    }

    h2,h3,h4,h5,h6 {
      font-family: ${({ theme }) => theme.fonts.secondary};
      color: ${({ theme }) => theme.colors.blackHigh};
    }

    .flex {
      display: flex;
      flex-direction: column;

      @media (min-width: ${breakpoints.lg}px) {
        flex-direction: row;
      }
    }

    .flex-reverse {
      display: flex;
      flex-direction: column-reverse;

      @media (min-width: ${breakpoints.lg}px) {
        flex-direction: row-reverse;
      }
    }

    .col-6 {
      flex-basis: auto;

      @media (min-width: ${breakpoints.lg}px) {
        flex-basis: calc(50%);
        margin: 48px 16px;
      }
    }
  }
`;

export const MarketHeader = styled.div`
  max-width: 1392px;
  margin: 0 auto;
  padding: 0 0 24px;

  .MuiTab-root {
    font-size: 0.85rem;
    letter-spacing: 0;
  }
`;

const marketsLayoutPropertyTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.node).isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  tabs: PropTypes.node,
  children: PropTypes.node,
};

type MarketsLayoutProperties = InferProps<typeof marketsLayoutPropertyTypes>;

const MarketsLayout = ({
  breadcrumbs, title, description, tabs, children,
}: MarketsLayoutProperties) => (
  <MarketGrid>
    <GridCell padding="0 20px 20px">
      <MarketHeader>
        <Breadcrumbs
          crumbs={breadcrumbs}
        />
        <StyledHeadline3 tag="h1">
          {title}
        </StyledHeadline3>
        <MarketDescription>
          {description}
        </MarketDescription>
        {tabs}
      </MarketHeader>
      <MarketBody>
        {children}
      </MarketBody>
    </GridCell>
  </MarketGrid>
);

MarketsLayout.propTypes = marketsLayoutPropertyTypes;

export default MarketsLayout;
